<script setup lang="ts">
  import type { IModal } from '@/components/ui/modal/types'

  defineProps<{
    blok: IModal
  }>()

  const isOpen = defineModel<boolean>()

  const title = ref(null)
  const titleSize = useElementSize(title)
  const sizeOffset = computed(() => {
    const titleMarginBottom = 8
    const containerPaddingBottom = 16

    return titleSize.height.value + titleMarginBottom + containerPaddingBottom
  })
</script>

<template>
  <DialogRoot
    v-if="blok.modalContent?.length"
    v-model:open="isOpen"
  >
    <DialogPortal>
      <DialogOverlay class="fixed inset-0 z-30 bg-black/75" />
      <DialogContent
        class="fixed left-1/2 top-0 z-40 h-dvh w-full -translate-x-1/2 bg-white p-4 md:top-10 md:h-[85%] md:w-186 md:translate-y-10 md:rounded-sm md:p-8"
      >
        <div class="mb-2 flex items-start justify-between gap-2 md:mb-4">
          <DialogTitle
            v-if="blok.modalTitle"
            ref="title"
            as="h5"
            class="mb-0"
          >
            {{ blok.modalTitle }}
          </DialogTitle>

          <DialogClose :aria-label="$t('close')">
            <Icon
              class="text-bt-blue-dark"
              name="common/close"
            />
          </DialogClose>
        </div>

        <div
          class="h-full overflow-y-auto pr-4 md:max-h-[85%]"
          :style="`max-height: calc(100% - ${sizeOffset}px)`"
        >
          <StoryblokComponent
            v-for="item in blok.modalContent"
            :key="item._uid"
            class="!mt-0"
            :blok="item"
          />
        </div>
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
